<template>
    <div>
      <div id="threescene" :style="background"></div>
      <div class="title-logo">
        数知了仓储环境监测3D可视化系统
      </div>
      <!-- <div class="contone">
        <div>
          <span class="biaoti">环境温湿度</span>
          <i-Switch @on-change="hjwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">包芯温湿度</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">虫情</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">烟垛信息</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
      </div>
      <div class="sidebar">
        侧边栏
      </div> -->
    </div>
  </template>
  
  <script>
  import * as THREE from "three";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
  import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
  import {
    getScene,
    getAxesHelper,
    createPoint,
    createAmbient,
    createGround,
    createCamera,
    createWebGLRenderer,
    createWallMaterail,
    createWallObject,
    createResultBsp,
    createWindow,
    createDoor,
    createElevator,
    createPillar,
    createSmokecrib,
    createRaycaster,
    cteateVector2,
  } from "../js/threejs.js";
  import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js"
  import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js"
  import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass.js"
  import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js"
  import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader.js"
  export default {
    name: "Three",
    data() {
      return {
        scene: null,
        camera: null,
        renderer: null,
        composer: null,
        width: 0,
        height: 0,
        matArrayB: [],
        raycaster: null,
        mouse: null,
        ambienthumiture: [], //环境温湿度铭牌集合
        corehumiture: [], //包芯温湿度铭牌集合
        background:{
          backgroundImage: "url('../img/icons/bcImg.png')",
                          backgroundRepeat: "no-repeat",
                          position: "fixed",
                          backgroundSize: "100% 100%",
        },
        datahm:[{'mac':'123',data:['20℃','30%']}],
        group:new THREE.Group()
      };
    },
    mounted() {
      
      this.init();
      window.addEventListener("click", this.onmodelclick, false);
    },
    methods: {
      init() {
        // 初始化画布宽高
        this.scene = getScene();
        this.raycaster = createRaycaster();
        this.mouse = cteateVector2();
        ///初始化
        //loadinit();
        /**
         * 辅助坐标系  参数1000表示坐标系大小
         */
        //var axisHelper = getAxesHelper(1000);
        //this.scene.add(axisHelper);
        //点光源
        var point = createPoint(0x444444, 1000, 500, 0);
        this.scene.add(point); //点光源添加到场景中
        //环境光
        var ambient = createAmbient(0xcccccc);
        this.scene.add(ambient);
        //创建一个地面网格
        // var ground = createGround(
        //   "../img/shuinidi.png",
        //   2000,
        //   3000,
        //   this.resetRender
        // );
        // this.scene.add(ground);
        /**
         * 相机设置
         */
        var width = window.innerWidth; //窗口宽度
        var height = window.innerHeight; //窗口高度
        var k = width / height; //窗口宽高比
        var s = 100000; //三维场景显示范围控制系数，系数越大，显示的范围越大
        //创建相机对象
        // var camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 1000);
        this.camera = createCamera(80, k, 0.5, 100000); //0.1, 100000场景渲染开始位置，最远能看到哪里
        this.camera.position.set(2000, 800, 0); //设置相机位置
        this.camera.lookAt(this.scene.position); //设置相机方向(指向的场景对象)position
        /**
         * 创建渲染器对象
         */
        this.renderer = createWebGLRenderer();
        this.renderer.setSize(width, height); //设置渲染区域尺寸
        //this.renderer.setClearColor(0xb9d3ff, 1); //设置背景颜色
        document.getElementById("threescene").appendChild(this.renderer.domElement); //body元素中插入canvas对象
        new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        this.resetRender();
        //监听鼠标、键盘事件
        var controls = new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        controls.addEventListener("change", () => {
          this.resetRender();
        });
        ///以下为添加具体的模型//////////////////////////////////////////////////////////////////////////////////////////
        //加载墙的材质
        this.matArrayB = createWallMaterail();
  
        ///添加墙（北）
        var wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 50, -1000, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 160, -1000, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 270, -1000, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 380, -1000, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 490, -1000, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 50, -1000, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 160, -1000, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 270, -1000, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 380, -1000, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 490, -1000, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 2000, 0.5, this.matArrayB, 0, 50, -1500, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 0.5, this.matArrayB, 0, 160, -1500, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 0.5, this.matArrayB, 0, 270, -1500, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 0.5, this.matArrayB, 0, 380, -1500, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 0.5, this.matArrayB, 0, 490, -1500, "墙面5");
        this.scene.add(wall);
  
        ///创建挖空的地面
        wall = createWallObject(3000, 5, 2000, 1.5, this.matArrayB, 0, 0, 0, "墙面");
        var door_cube1 = createWallObject(600, 5, 1000, 0, this.matArrayB, -700, 0, 0, "前门1");
        var door_cube2 = createWallObject(600, 5, 1000, 0, this.matArrayB, 700, 0, 0, "前门1");
        // var window_cube1 = createWallObject(120, 70, 200, 0, this.matArrayB, -700, 50, -500, "窗户1");
        // var window_cube2 = createWallObject(120, 70, 200, 0, this.matArrayB, 700, 50, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        // objects_cube.push(window_cube1);
        // objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
  
         ///创建挖空的楼顶
         wall = createWallObject(3000, 5, 2000, 1.5, this.matArrayB, 0, 520, 0, "墙面");
        var door_cube1 = createWallObject(600, 5, 1000, 0, this.matArrayB, -700, 520, 0, "前门1");
        var door_cube2 = createWallObject(600, 5, 1000, 0, this.matArrayB, 700, 520, 0, "前门1");
        // var window_cube1 = createWallObject(120, 70, 200, 0, this.matArrayB, -700, 50, -500, "窗户1");
        // var window_cube2 = createWallObject(120, 70, 200, 0, this.matArrayB, 700, 50, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        // objects_cube.push(window_cube1);
        // objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
  
        ///创建挖空的墙
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, -500, "墙面1");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 40, -500, "前门1");
        var window_cube1 = createWallObject(120, 70, 200, 0, this.matArrayB, -700, 50, -500, "窗户1");
        var window_cube2 = createWallObject(120, 70, 200, 0, this.matArrayB, 700, 50, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 70, 2, 0, -700, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, 700, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 160, -500, "墙面2");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 150, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 160, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 160, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 270, -500, "墙面3");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 260, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 270, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 270, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 380, -500, "墙面4");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 370, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 380, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 380, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, 700, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 490, -500, "墙面5");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 480, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 490, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 490, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
  
         ///添加挖空的墙（过道）
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 50, 0, "墙面1");
        var door_cube1 = createWallObject(240, 90, 5, 0.5, this.matArrayB, 400, 45, 0, "前门1");
        var door_cube2 = createWallObject(100, 90, 5, 0.5, this.matArrayB, 400, 45, -400, "电梯1");
        var door_cube3 = createWallObject(100, 90, 5, 0.5, this.matArrayB, 400, 45, 400, "电梯2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        objects_cube.push(door_cube3);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var door_cube = createElevator(100, 90, 2, 0.5, 400, 45, -400, "安装窗户", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createElevator(100, 90, 2, 0.5, 400, 45, 400, "安装窗户", this.resetRender);
        this.scene.add(door_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 160, 0, "墙面2");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, 400, 160, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, 400, 160, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 270, 0, "墙面3");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, 400, 270, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, 400, 270, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 380, 0, "墙面4");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, 400, 380, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, 400, 380, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 490, 0, "墙面5");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, 400, 490, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, 400, 490, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -400, 50, 0, "墙面1");
        var door_cube1 = createWallObject(240, 90, 5, 0.5, this.matArrayB, -400, 45, 0, "前门1");
        var door_cube2 = createWallObject(100, 90, 5, 0.5, this.matArrayB, -400, 45, -400, "电梯1");
        var door_cube3 = createWallObject(100, 90, 5, 0.5, this.matArrayB, -400, 45, 400, "电梯2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        objects_cube.push(door_cube3);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var door_cube = createElevator(100, 90, 2, 0.5, -400, 45, -400, "安装窗户", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createElevator(100, 90, 2, 0.5, -400, 45, 400, "安装窗户", this.resetRender);
        this.scene.add(door_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -400, 160, 0, "墙面2");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, -400, 160, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, -400, 160, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -400, 270, 0, "墙面3");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, -400, 270, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, -400, 270, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -400, 380, 0, "墙面4");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, -400, 380, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, -400, 380, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -400, 490, 0, "墙面5");
        var window_cube1 = createWallObject(240, 50, 5, 0.5, this.matArrayB, -400, 490, 0, "窗户1");
        var objects_cube = [];
        objects_cube.push(window_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(2, 50, 240, 0, -400, 490, 0, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
        
  
  
  
        //  var wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 50, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 160, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 270, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 380, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 400, 490, 0);
        // this.scene.add(wall);
  
        // wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -400, 50, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -400, 160, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -400, 270, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -400, 380, 0);
        // this.scene.add(wall);
        // wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -400, 490, 0);
        // this.scene.add(wall);
  
  
  
        ///添加墙（南）
        var wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 50, 1000, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 160, 1000, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 270, 1000, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 380, 1000, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 490, 1000, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 50, 1000, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 160, 1000, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 270, 1000, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 380, 1000, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 490, 1000, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, 1500, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 160, 1500, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 270, 1500, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 380, 1500, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 490, 1500, "墙面5");
        this.scene.add(wall);
        
        ///创建挖空的墙
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, 500, "墙面1");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 40, 500, "前门1");
        var window_cube1 = createWallObject(120, 70, 200, 0, this.matArrayB, -700, 50, 500, "窗户1");
        var window_cube2 = createWallObject(120, 70, 200, 0, this.matArrayB, 700, 50, 500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 70, 2, 0, -700, 50, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, 700, 50, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 160, 500, "墙面2");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 150, 500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 160, 500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 160, 500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 160, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 160, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 270, 500, "墙面3");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 260, 500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 270, 500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 270, 500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 270, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 270, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 380, 500, "墙面4");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 370, 500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 380, 500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 380, 500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 380, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 380, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 490, 500, "墙面5");
        var door_cube1 = createWallObject(180, 90, 5, 0, this.matArrayB, 0, 480, 500, "前门1");
        var window_cube1 = createWallObject(120, 50, 200, 0, this.matArrayB, -700, 490, 500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 200, 0, this.matArrayB, 700, 490, 500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 50, 2, 0, -700, 490, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 700, 490, 500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
  
        //添加柱子（北）
        // var pillar = createPillar(40, 100, 40, -600, 50, -1100,'柱子1');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -200, 50, -1100,'柱子2');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 200, 50, -1100,'柱子3');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 600, 50, -1100,'柱子4');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -600, 50, -850,'柱子5');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -200, 50, -850,'柱子6');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 200, 50, -850,'柱子7');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 600, 50, -850,'柱子8');
        // this.scene.add(pillar);
  
        //添加柱子（南）
        // var pillar = createPillar(40, 100, 40, -600, 50, 1100,'柱子1');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -200, 50, 1100,'柱子2');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 200, 50, 1100,'柱子3');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 600, 50, 1100,'柱子4');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -600, 50, 850,'柱子5');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, -200, 50, 850,'柱子6');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 200, 50, 850,'柱子7');
        // this.scene.add(pillar);
        // pillar = createPillar(40, 100, 40, 600, 50, 850,'柱子8');
        // this.scene.add(pillar);
        
        
        
        ///添加烟垛（北）
        // var smokecrib = createSmokecrib(120, 100, 240, -800, 50, -1280, this.resetRender,'烟垛A1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -600, 50, -1280, this.resetRender,'烟垛A2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -400, 50, -1280, this.resetRender,'烟垛A3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -200, 50, -1280, this.resetRender,'烟垛A4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 0, 50, -1280, this.resetRender,'烟垛A5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 200,  50, -1280, this.resetRender,'烟垛A6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 400,  50, -1280, this.resetRender,'烟垛A7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 600, 50, -1280, this.resetRender,'烟垛A8');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 800, 50, -1280, this.resetRender,'烟垛A9');
        // this.scene.add(smokecrib);
  
        // smokecrib = createSmokecrib(120, 100, 180, -800, 50, -680, this.resetRender,'烟垛B1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -600, 50, -680, this.resetRender,'烟垛B2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -400, 50, -680, this.resetRender,'烟垛B3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -200, 50, -680, this.resetRender,'烟垛B4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 200, 50, -680, this.resetRender,'烟垛B5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 400, 50, -680, this.resetRender,'烟垛B6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 600, 50, -680, this.resetRender,'烟垛B7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 800, 50, -680, this.resetRender,'烟垛B8');
        // this.scene.add(smokecrib);
  
        ///添加烟垛（南）
        // var smokecrib = createSmokecrib(120, 100, 240, -800, 50, 1280, this.resetRender,'烟垛A1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -600, 50, 1280, this.resetRender,'烟垛A2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -400, 50, 1280, this.resetRender,'烟垛A3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, -200, 50, 1280, this.resetRender,'烟垛A4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 0, 50, 1280, this.resetRender,'烟垛A5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 200,  50, 1280, this.resetRender,'烟垛A6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 400,  50, 1280, this.resetRender,'烟垛A7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 600, 50, 1280, this.resetRender,'烟垛A8');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 800, 50, 1280, this.resetRender,'烟垛A9');
        // this.scene.add(smokecrib);
  
        // smokecrib = createSmokecrib(120, 100, 180, -800, 50, 680, this.resetRender,'烟垛B1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -600, 50, 680, this.resetRender,'烟垛B2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -400, 50, 680, this.resetRender,'烟垛B3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, -200, 50, 680, this.resetRender,'烟垛B4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 200, 50, 680, this.resetRender,'烟垛B5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 400, 50, 680, this.resetRender,'烟垛B6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 600, 50, 680, this.resetRender,'烟垛B7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 800, 50, 680, this.resetRender,'烟垛B8');
        // this.scene.add(smokecrib);
  
  
  
        // var smokecrib = createSmokecrib(240, 100, 160, 300, 40, 300, this.resetRender,'烟垛1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, 300, this.resetRender,'烟垛2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, 300, this.resetRender,'烟垛3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 300, 40, 0, this.resetRender,'烟垛4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, 0, this.resetRender,'烟垛5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, 0, this.resetRender,'烟垛6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 300,  40, -300, this.resetRender,'烟垛7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, -300, this.resetRender,'烟垛8');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, -300, this.resetRender,'烟垛9');
        // this.scene.add(smokecrib);
  
  
        //加载外部模型---包芯温湿度（北）
        // this.createFBX('../img/baoxin.fbx',-720, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-120, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',80, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',280, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',880, 50, -1320, 0, 0, 1.5, 1, 1, 1,'123');
  
        // this.createFBX('../img/baoxin.fbx',-720, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-120, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',280, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',880, 50, -680, 0, 0, 1.5, 1, 1, 1,'123');
  
        //加载外部模型---包芯温湿度（南）
        // this.createFBX('../img/baoxin.fbx',-720, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-120, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',80, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',280, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',880, 50, 1320, 0, 0, 1.5, 1, 1, 1,'123');
  
        // this.createFBX('../img/baoxin.fbx',-720, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-120, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',280, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',880, 50, 680, 0, 0, 1.5, 1, 1, 1,'123');
  
  
        //加载外部模型---环境温湿度（北）
        // this.createFBX('../img/huanjing.fbx',-600, 70, -1080, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-200, 70, -1080, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',200, 70, -1080, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, -1080, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-600, 70, -830, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-200, 70, -830, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',200, 70, -830, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, -830, 0, 1.56, 0, 0.5, 0.5, 0.5);
  
        //加载外部模型---环境温湿度（南）
        // this.createFBX('../img/huanjing.fbx',-600, 70, 1120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-200, 70, 1120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',200, 70, 1120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, 1120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-600, 70, 870, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-200, 70, 870, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',200, 70, 870, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, 870, 0, 1.56, 0, 0.5, 0.5, 0.5);
  
        ////添加环境铭牌
        this.createNameplate();
        ////添加包芯铭牌
        this.createNameplatebx();
        
      },
      ///加载模型显示
      resetRender(obj) {
        //console.log(obj);
        this.renderer.render(this.scene, this.camera);
      },
      ///加载外部模型
    ///path 模型地址
    ///posx 模型在x轴上的位置
    ///posy 模型在y轴上的位置
    ///posz 模型在z轴上的位置
     ///rotx 模型在x轴上旋转角度
    ///roty 模型在y轴上旋转角度
    ///rotz 模型在z轴上旋转角度
    ///zoomx 模型在x轴上缩放比例
    ///zoomy 模型在y轴上缩放比例
    ///zoomz 模型在z轴上缩放比例
    createFBX(path,posx,posy,posz,rotx,roty,rotz,zoomx,zoomy,zoomz,name) {
      const loader = new FBXLoader();
      let _this=this;
      loader.load(path, function (obj) {
        //obj.scale.x = obj.scale.y = obj.scale.z = 100;
        //obj.rotation.y = 500;
        obj.rotation.y =rotx;
          obj.rotation.x = roty;
          obj.rotation.z = rotz;//模型的角度
        //let mesh = obj;
        obj.position.x = posx;//模型所在位置
        obj.position.y = posy;//模型所在位置
        obj.position.z = posz;//模型所在位置
        obj.scale.set(zoomx, zoomy, zoomz);//模型缩放比例
        obj.name=name;
        _this.group.add(obj);
        _this.scene.add(_this.group);
        _this.resetRender('外部模型');
      });
    },
       //创建包芯温湿度一个铭牌
       createNameplatebx() {
        //var geometry = new THREE.BoxGeometry( 30,30, 30 );
        var materials = [
          new THREE.MeshPhongMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // right
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // left
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // top
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // bottom
          new THREE.MeshBasicMaterial({
            color: 0x3399ff,
            map: new THREE.CanvasTexture(this.getTextCanvas1("包芯温湿度")),
            opacity: 0.9,
            transparent: false,
          }), // back
          new THREE.MeshBasicMaterial({
            color: 0x3399ff,
            map: new THREE.CanvasTexture(this.getTextCanvas1("包芯温湿度")),
            opacity: 0.9,
            transparent: false,
          }), // front
        ];
        var material = new THREE.MeshLambertMaterial({
          color: 0x3399ff,
          opacity: 0.9, //透明度 0-1
          transparent: false, //开启透明度
        });
  
        var wall = createWallObject(2,50,2,0,material,300,90,300,"支柱1",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,300,160,300,"铭牌1",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        var wall = createWallObject(2,50,2,0,material,-300,90,300,"支柱2",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,-300,160,300,"铭牌2",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        var wall = createWallObject(2,120,2,0,material,300,140,-300,"支柱3",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,300,260,-300,"铭牌3",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(2,120,2,0,material,-300,140,-300,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,-300,260,-300,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
  
        wall = createWallObject(2,120,2,0,material,300,120,0,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,300,240,0,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
  
        wall = createWallObject(2,120,2,0,material,0,120,0,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,0,240,0,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
  
        wall = createWallObject(2,120,2,0,material,-300,120,0,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,-300,240,0,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
  
        wall = createWallObject(2,50,2,0,material,0,100,300,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,0,160,300,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
  
        wall = createWallObject(2,120,2,0,material,0,140,-300,"支柱4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
        wall = createWallObject(240,120,4,0,materials,0,260,-300,"铭牌4",false);
        this.scene.add(wall);
        this.corehumiture.push(wall);
      },
      //创建环境温湿度一个铭牌
      createNameplate() {
        //var geometry = new THREE.BoxGeometry( 30,30, 30 );
        var materials = [
          new THREE.MeshPhongMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // right
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // left
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // top
          new THREE.MeshBasicMaterial({
            color: 0xafc0ca,
            opacity: 0.4,
            transparent: true,
          }), // bottom
          new THREE.MeshBasicMaterial({
            color: 0x55aa77,
            map: new THREE.CanvasTexture(this.getTextCanvas1("环境温湿度")),
            opacity: 0.9,
            transparent: true,
          }), // back
          new THREE.MeshBasicMaterial({
            color: 0x55aa77,
            map: new THREE.CanvasTexture(this.getTextCanvas1("环境温湿度")),
            opacity: 0.9,
            transparent: true,
          }), // front
        ];
        var material = new THREE.MeshLambertMaterial({
          color: 0x55aa77,
          opacity: 0.9, //透明度 0-1
          transparent: false, //开启透明度
        });
  
        var wall = createWallObject(
          2,
          50,
          2,
          0,
          material,
          -200,
          100,
          100,
          "支柱1",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        wall = createWallObject(
          240,
          120,
          4,
          0,
          materials,
          -200,
          180,
          100,
          "铭牌1",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        var wall = createWallObject(
          2,
          50,
          2,
          0,
          material,
          200,
          100,
          100,
          "支柱2",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        wall = createWallObject(
          240,
          120,
          2,
          0,
          materials,
          200,
          180,
          100,
          "铭牌2",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        var wall = createWallObject(
          2,
          100,
          2,
          0,
          material,
          200,
          150,
          -200,
          "支柱3",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        wall = createWallObject(
          240,
          120,
          2,
          0,
          materials,
          200,
          260,
          -200,
          "铭牌3",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        var wall = createWallObject(
          2,
          100,
          2,
          0,
          material,
          -200,
          150,
          -200,
          "支柱4",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
        wall = createWallObject(
          240,
          120,
          2,
          0,
          materials,
          -200,
          260,
          -200,
          "铭牌4",
          false
        );
        this.scene.add(wall);
        this.ambienthumiture.push(wall);
      },
      // CanvasTexture
      getTextCanvas1(title) {
        let texts = [
          { name: "温度", value: "32℃" },
          { name: "湿度", value: "56%" },
        ];
        var width = 1000,
          height = 500;
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#55AA77";
        ctx.fillRect(0, 0, width, height);
        ctx.font = 120 + 'px " bold';
        ctx.fillStyle = "#ffffff";
        //ctx.fillText(texts, width/2,height/2);
        ctx.fillText(title, 200, 120);
        texts.forEach((text, index) => {
          ctx.fillText(`${text.name}:${text.value}`, 230, 120 * index + 300);
        });
        return canvas;
      },
      ///点击事件
      onmodelclick(event) {
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
  
        // 计算物体和射线的焦点
        var intersects = this.raycaster.intersectObjects(this.scene.children);
       
  
        var ress = intersects.filter(function (res) {
          return res && res.object;
        });
        
  
        //点击事件
        var res = intersects.filter(function (res) {
          return res && res.object;
        })[0];
        if (res && res.object) {
          //console.log(res)
          var selectObject = res.object;
          //alert(selectObject.name)
          // if (selectObject.name == "123456") {
          //   //$(".contone").show();
          // } else {
          //   //$(".contone").hide();
          // }
         // console.log(selectObject.name);
  
          //window.location.href = "test111.html";
  
          // console.log(selectObject.name.indexOf('墙面'));
          // this.outlineObj([selectObject]);
          // this.$router.push('/yanye/one-floor');

          let name=selectObject.name;
          window.removeEventListener('click',  this.onmodelclick, false)
          if(name=="墙面5"){
            this.outlineObj([selectObject]);
            this.$router.push("/yanye/five-floor");
          }else if(name=="墙面4"){
            this.outlineObj([selectObject]);
            this.$router.push("/yanye/four-floor");
          }else if(name=="墙面3"){
            this.outlineObj([selectObject]);
            this.$router.push("/yanye/three-floor");
          }else if(name=="墙面2"){
            this.outlineObj([selectObject]);
            this.$router.push("/yanye/two-floor");
          }else{
            this.outlineObj([selectObject]);
            this.$router.push("/yanye/one-floor");
          }
        }
      },
  
      animate() {
      requestAnimationFrame( this.animate );
      this.renderer.render( this.scene, this.camera );
      //controls.update();
      if (this.composer) {
          this.composer.render()
        }
  },
  
      outlineObj (selectedObjects) {
        // 创建一个EffectComposer（效果组合器）对象，然后在该对象上添加后期处理通道。
        this.composer = new EffectComposer(this.renderer)
        // 新建一个场景通道  为了覆盖到原理来的场景上
        let renderPass = new RenderPass(this.scene, this.camera)
        this.composer.addPass(renderPass);
        let _this=this;
        // 物体边缘发光通道
        let outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), _this.scene, _this.camera, selectedObjects)
        outlinePass.selectedObjects = selectedObjects
        outlinePass.edgeStrength = 5.0 // 边框的亮度
        outlinePass.edgeGlow = 1// 光晕[0,1]
        outlinePass.usePatternTexture = false // 是否使用父级的材质
        outlinePass.edgeThickness = 10.0 // 边框宽度
        outlinePass.downSampleRatio = 1 // 边框弯曲度
        outlinePass.pulsePeriod = 2 // 呼吸闪烁的速度
        outlinePass.visibleEdgeColor.set(parseInt(0x00ff00)) // 呼吸显示的颜色
        outlinePass.hiddenEdgeColor = new THREE.Color(0, 0, 0) // 呼吸消失的颜色
        outlinePass.clear = true
        this.composer.addPass(outlinePass)
        // 自定义的着色器通道 作为参数
        var effectFXAA = new ShaderPass(FXAAShader)
        effectFXAA.uniforms.resolution.value.set(1 / window.innerWidth, 1 / window.innerHeight)
        effectFXAA.renderToScreen = true
        this.composer.addPass(effectFXAA)
        //composer.render();
        this.animate();
      },
  
      //环境温湿度显示
      hjwsd(event) {
        //console.log(this.ambienthumiture);
        this.ambienthumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
      //环境温湿度显示
      bxwsd(event) {
        //console.log(this.ambienthumiture);
        this.corehumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
    },
  };
  </script>
  
  <style scoped>


    #threescene{
      width: 100%;
      height: 100%;
  
    }
  
  .title-logo {
    position: fixed;
    top: 0;
    width: 100%;
    height: 80px;
    color: #00ffff;
    font-family: none;
    font-size: 24px;
    font-weight: bold;
    line-height: 70px;
    background-image: url(../../../../public/img/icons/header_logo-1.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin: 0 auto;
    text-align: center;
    }
  
  .contone {
    /* width: 200px;
    height: 200px; */
    z-index: 99999;
    position: absolute;
    top: 100px;
    left: 40px;
    text-align: left;
    /* border: #fff 1px solid; */
    padding: 5px 15px;
    box-shadow: 0 0 2px #00ffff inset;
    background: linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) right bottom, linear-gradient(#00ffff, #00ffff) right bottom;
    background-repeat: no-repeat;
    background-size: 1px 10px, 10px 1px;
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .biaoti {
    color: #fff;
    font-size: 16px;
    margin-right: 10px;
    line-height: 40px;
  }
  
  .ivu-switch-large {
      width: 44px!important;
  }
  
  .ivu-switch-large.ivu-switch-checked:after {
      left: 23px!important;
  }
  
  </style>